import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/tag/store",
    data: data,
  });
};

export const GetData = async (pageNumber, limit = 15) => {
  return await Get({
    url: "/tag/show_list",
    data: {
      limit: limit,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/tag/destroy",
    data: data,
  });
};

export const EditData = async data => {
  await Set({
    url: "/tag/update",
    data: data,
  });
};
export const DataSearch = async (data, limit = 15, page = null) => {
  return await Get({
    url: "/tag/show_list",
    data: {
      limit: limit,
      ...data,
    },
    page: page,
  }).then(data => {
    return data;
  });
};
